// extracted by mini-css-extract-plugin
module.exports = {"container":"SubMenu_container__3Dr3r","version":"SubMenu_version__rhCro","menu":"SubMenu_menu__1hW8g","buttonsContainer":"SubMenu_buttonsContainer__PyYLP"};